import React, { useEffect } from "react";
import { createModal } from "../hooks/createModal";

export default function OrderForm() {



    useEffect(() => {
        const callOrder = (e) => { onOrder(e.detail); };
        window.addEventListener("callOrder", callOrder);
        return () => {
            window.removeEventListener("callOrder", callOrder)
        };
    }, []);


    const drawForm = () => {

        return(<>
        
        </>)
    }

    const onOrder = (_order) => {

        console.log(_order)
        createModal({
            offset: [0, -80], title : "Order Form",
            component: <>{JSON.stringify(_order.data, null, 2)}</>, closable: true, callback: (e) => {
                
                 if (typeof _order.callback === "function") {
                    _order.callback("thing")    
                 }
                
            }
        })

    }



    return (<></>)
}